import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NbIconModule, NbPopoverModule } from '@nebular/theme'
import { NbEvaIconsModule } from '@nebular/eva-icons'

import { RetentionBadgeComponent } from './retention-badge.component'

@NgModule({
  declarations: [ RetentionBadgeComponent ],
  imports: [ CommonModule, NbIconModule, NbEvaIconsModule, NbPopoverModule ],
  exports: [ RetentionBadgeComponent ]
})
export class RetentionBadgeModule {}
